import React, { lazy } from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'

const Posts = lazy(() => import('../../container/posts'))

const PostsRoutes = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path} component={Posts} />
    </Switch>
  )
}

export default PostsRoutes
